var _rect, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.351562,
    y: 0.351562,
    width: 21.7969,
    height: 21.7969,
    rx: 10.8984,
    stroke: "#303436",
    strokeOpacity: 0.35,
    strokeWidth: 0.703125,
    strokeDasharray: "2.81 2.81"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.25C12.8039 11.25 14.0625 9.99141 14.0625 8.4375C14.0625 6.88359 12.8039 5.625 11.25 5.625C9.69609 5.625 8.4375 6.88359 8.4375 8.4375C8.4375 9.99141 9.69609 11.25 11.25 11.25ZM11.25 12.6562C9.37266 12.6562 5.625 13.5984 5.625 15.4687V16.1719C5.625 16.5586 5.94141 16.875 6.32812 16.875H16.1719C16.5586 16.875 16.875 16.5586 16.875 16.1719V15.4687C16.875 13.5984 13.1273 12.6562 11.25 12.6562Z",
    fill: "#303436",
    fillOpacity: 0.35
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.75,
    cy: 18.7501,
    r: 4.375,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 14.375C16.335 14.375 14.375 16.335 14.375 18.75C14.375 21.165 16.335 23.125 18.75 23.125C21.165 23.125 23.125 21.165 23.125 18.75C23.125 16.335 21.165 14.375 18.75 14.375ZM20.5 19.1875H19.1875V20.5C19.1875 20.7406 18.9906 20.9375 18.75 20.9375C18.5094 20.9375 18.3125 20.7406 18.3125 20.5V19.1875H17C16.7594 19.1875 16.5625 18.9906 16.5625 18.75C16.5625 18.5094 16.7594 18.3125 17 18.3125H18.3125V17C18.3125 16.7594 18.5094 16.5625 18.75 16.5625C18.9906 16.5625 19.1875 16.7594 19.1875 17V18.3125H20.5C20.7406 18.3125 20.9375 18.5094 20.9375 18.75C20.9375 18.9906 20.7406 19.1875 20.5 19.1875Z",
    fill: "#303436",
    fillOpacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAdd);
export default __webpack_public_path__ + "static/media/person-add.83181750a12cd39a79a935b88c5e5f0f.svg";
export { ForwardRef as ReactComponent };